import React from "react";
import "../Style/Aboutus.css";
import NavBar from "../Components/HomeSections/NavBar";
import Header from "../Components/HomeSections/Header";
import Footer from "../Components/HomeSections/Footer";
import { Helmet } from "react-helmet";
const Aboutus = () => {
  return (
    <>
          <Helmet>
        <title>
          Meet Di Henneberry | Henneberry Property Group Sydney
        </title>
        <meta
          name="description"
          content="Meet Di Henneberry, a multi-award-winning property professional with 20+ years’ experience delivering refined property services across Sydney and NSW."
        />
      </Helmet>
      <div className="banner_bg">
        <NavBar />
        <Header />
        <h1 className="d-flex align-items-center justify-content-center" style={{color:"#f7e0b3"}}>
          About Us
        </h1>
      </div>
      <div className="container">
        <div className="about-contact">
          <h3>MEET DI HENNEBERRY</h3>
          <p>
            Henneberry Property Group, owned by Di Henneberry, offers a high-quality property service throughout Sydney and New South Wales, backed by extensive industry experience and a passion for tailored service.<br/>
            Awarded and respected for her 20-year career in real estate, Di has chosen to work with Sydney’s elite property organisations. This has allowed Di to refine her extensive knowledge and implement a focused and detail-oriented service with all her clients. Whether you are looking for Sydney property to buy and to invest in, property to sell, or would like a property managed, Di has designed a service around your needs.<br/>
            Di's service is thoroughly considered, planned and executed with her clients in mind. This can involve everything from a thorough property viewing and analysis, and considering the potential for growth from an investment perspective in the long term. Di looks at the often overlooked, yet important small features of a property, that can impact the value and its future returns as well as the lifestyle of its occupants.<br/>
            Specialising in Sydney’s eastern suburbs and the rest of New South Wales, the experienced team at Henneberry Property Group have the knowledge to provide clients with property service that will help clients make confident decisions within the real estate market.

          </p>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Aboutus;
